import { render } from "./IconList.vue?vue&type=template&id=644a3a68"
const script = {}

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__